import { render } from "./NewProductHighlights.vue?vue&type=template&id=1cfafc76"
import script from "./NewProductHighlights.vue?vue&type=script&lang=js"
export * from "./NewProductHighlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/NewProductHighlights.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cfafc76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cfafc76', __exports__)) {
    api.reload('1cfafc76', __exports__)
  }
  
  module.hot.accept("./NewProductHighlights.vue?vue&type=template&id=1cfafc76", () => {
    api.rerender('1cfafc76', render)
  })

}


export default __exports__